import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {Vendors} from './vendors.entity';
import {VendorsDTO} from './dto/vendors.dto';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { VendorsService } from './vendors.service';
import {VendorsResponseModel, AllVendorsResponseModel, VendorsDropDownResponseModel} from '@gtpl/shared-models/masters';
import { VendorRequest } from './dto/vendors.request';
import { CommonResponse } from '@gtpl/shared-models/production-management';

@ApiTags('Vendors')
@Controller('Vendors')
export class VendorsController {
    constructor(
        private vendorService: VendorsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createVendor')
    async createVendor(@Body() vendorDto:VendorsDTO,isUpdate:boolean=false): Promise<VendorsResponseModel> {
    try {
        console.log(vendorDto);
        return await this.vendorService.createVendor(vendorDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(VendorsResponseModel, error);
      }
    }
    @Post('/updateVendor')
  async updateVendor(@Body() vendorDto: VendorsDTO,@Req() request:Request): Promise<VendorsResponseModel> {
    try {
      console.log('update Vendor');
      console.log(request);
      return await this.vendorService.createVendor(vendorDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VendorsResponseModel, error);
    }
  }
  @Post('/getAllVendors')
  // @UseGuards(AuthGuard('jwt'))
  async getAllVendors(): Promise<CommonResponse> {

    try {
      return await this.vendorService.getAllVendors();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllVendorsResponseModel, error);
    }
  }
  @Post('/getAllActiveVendors')
  async getAllActiveVendors(@Req() request: Request): Promise<AllVendorsResponseModel> {
      try {
          return await this.vendorService.getAllActiveVendors();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllVendorsResponseModel, error)
      }
  }
  @Post('/activateOrDeactivateVendor')
  async activateOrDeactivateVendor(@Body() Vendorreq: VendorRequest): Promise<VendorsResponseModel> {
      try {
          return await this.vendorService.activateOrDeactivateVendor(Vendorreq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(VendorsResponseModel, err);
      }
  }

  @Post('/getVendorDataById')
  async getVendorDataById(@Body() vendorRequest:VendorRequest): Promise<VendorsResponseModel> {
    try {
      console.log(vendorRequest);
        return await this.vendorService.getVendorDataById(vendorRequest);
    } catch (error) {
       throw error;
    }
  }

  @Post('/getVendorsDropDownData')
  async getVendorsDropDownData(): Promise<VendorsDropDownResponseModel> {
    try {
        return await this.vendorService.getVendorsDropDownData();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VendorsDropDownResponseModel, error);
    }
  }
  @Post('/getCurrenciesByVendorId')
  async getCurrenciesByVendorId(@Body() vendorRequest:VendorRequest): Promise<AllVendorsResponseModel> {
    try {
        return await this.vendorService.getCurrenciesByVendorId(vendorRequest);
    } catch (error) {
       throw error;
    }
  }

}
